import { useMutation } from '@tanstack/react-query';
import { BASE_URL_LANG } from '@/api/utils.ts';
import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  PortfolioConnectPostError,
  PortfolioConnectPostParams,
  PortfolioConnectPostResponse,
} from '@/api/model/authentication/portfolio.ts';

const usePortfolioConnectPost = () =>
  useMutation<
    AxiosResponse<PortfolioConnectPostResponse>,
    AxiosError<PortfolioConnectPostError>,
    PortfolioConnectPostParams
  >({
    mutationFn: ({ email, password, sec_token, sendLogin }) => {
      const body = new FormData();
      body.append('sendLogin', sendLogin);
      body.append('email', email);
      body.append('password', password);
      body.append('sec_token', sec_token);

      return axios.post(`${BASE_URL_LANG}portfolio/connect`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // Backend requires this header
          internal: 1,
        },
      });
    },
  });

export { usePortfolioConnectPost };
